module.exports = __webpack_public_path__ + "img/caretDown.bbd03316.svg";